import { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AppShell } from './components/AppShell';
import { Login } from './screens/Login';

// Route-level code splitting. Every screen used to sit in the entry chunk, so a
// cold load downloaded and parsed all seven — plus the chart and drawer code
// behind them — before rendering the one the user asked for. Login and the
// shell stay eager (they're on every path); the rest load per route and are
// warm in cache by the time the user navigates.
const Dashboard = lazy(() => import('./screens/Dashboard').then((m) => ({ default: m.Dashboard })));
const Transactions = lazy(() =>
  import('./screens/Transactions').then((m) => ({ default: m.Transactions })),
);
const Invoices = lazy(() => import('./screens/Invoices').then((m) => ({ default: m.Invoices })));
const Clients = lazy(() => import('./screens/Clients').then((m) => ({ default: m.Clients })));
const Accuracy = lazy(() => import('./screens/Accuracy').then((m) => ({ default: m.Accuracy })));
const Alerts = lazy(() => import('./screens/Alerts').then((m) => ({ default: m.Alerts })));
const Settings = lazy(() => import('./screens/Settings').then((m) => ({ default: m.Settings })));

/** Shown only for the moment a route chunk is in flight. */
function ScreenFallback() {
  return (
    <div className="auth-splash">
      <span className="auth-splash-dot" />
      Loading…
    </div>
  );
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <ProtectedRoute>
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route
          path="/dashboard"
          element={
            <Suspense fallback={<ScreenFallback />}>
              <Dashboard />
            </Suspense>
          }
        />
        <Route
          path="/transactions"
          element={
            <Suspense fallback={<ScreenFallback />}>
              <Transactions />
            </Suspense>
          }
        />
        <Route
          path="/invoices"
          element={
            <Suspense fallback={<ScreenFallback />}>
              <Invoices />
            </Suspense>
          }
        />
        <Route
          path="/clients"
          element={
            <Suspense fallback={<ScreenFallback />}>
              <Clients />
            </Suspense>
          }
        />
        <Route
          path="/accuracy"
          element={
            <Suspense fallback={<ScreenFallback />}>
              <Accuracy />
            </Suspense>
          }
        />
        <Route
          path="/alerts"
          element={
            <Suspense fallback={<ScreenFallback />}>
              <Alerts />
            </Suspense>
          }
        />
        <Route
          path="/settings"
          element={
            <Suspense fallback={<ScreenFallback />}>
              <Settings />
            </Suspense>
          }
        />
      </Route>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
